module.exports = __webpack_public_path__ + "static/media/outlook.58830c27.png";